import {
  $createNodeSelection,
  $createParagraphNode,
  $isParagraphNode,
  $setSelection,
} from 'lexical';
import logException from '@dashboard/services/logException';

export const $insertAndSelectNode = ({ selectedNode, newNode }) => {
  try {
    const selectedIsParagraph = $isParagraphNode(selectedNode);
    const selectedIsEmpty = selectedNode.getTextContent() === '';

    selectedNode.getTopLevelElementOrThrow().insertAfter(newNode);

    if (selectedIsParagraph && selectedIsEmpty) {
      selectedNode.remove();
    }

    const nodeSelection = $createNodeSelection();
    nodeSelection.add(newNode.getKey());
    $setSelection(nodeSelection);

    // always follow the inserted card with a blank paragraph when inserting at end of document
    if (!newNode.getNextSibling() && !$isParagraphNode(newNode)) {
      const paragraph = $createParagraphNode();
      newNode.insertAfter(paragraph);
    }
  } catch (e) {
    logException(e);
  }
};
